// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__guWlt","fullView":"styles_fullView__a_REp"};